import React, { useEffect, useMemo } from "react";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";

import { getKPIsNrOfProjects } from "modules/reporting/fordReports/kpis/store/kpis.actions";
import { makeActualScoreCardFilterData } from "modules/reporting/fordReports/utils";
import LoadingComponent from "modules/primitives/loading/loading.component";
import styles from './styles.module.scss';
import genericStyles from '../../styles.module.scss';
import { rangeToPercent } from "modules/reporting/utils";
import { CHART_COLORS } from "modules/companies/companyMain/chartsWrapper/chartsView/charts-constants";

const FordNrOfProjectsStages = ({ nrOfProjectsStages, filters }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    if (!nrOfProjectsStages.data) {
      const makeFilters = makeActualScoreCardFilterData(filters);
      const payload = {
        enqueueSnackbar,
        data: makeFilters,
      };

      dispatch(getKPIsNrOfProjects(payload))
    }
  }, []);

  return (
    <div className={genericStyles.columnCard}>
      <span className={genericStyles.columnCardTitle}>Projects/Stage</span>
      {
        nrOfProjectsStages.fetching ? (
          <LoadingComponent customText="Getting Projects/Stages..." />
        ) : (
          <div className="d-flex flex-row">
            <span className={styles.verticalText}>Project Stage</span>
            <div className={styles.horizontalBarsWrapper}>
              {
                nrOfProjectsStages.data?.map((el, idx) => {
                  const width = rangeToPercent(el);

                  return (
                    <div
                      key={el.id}
                      className="d-flex align-items-center mb-1"
                    >
                      <div className={`${styles.barName}`}>
                        {el.name}
                      </div>
                      <div className="d-flex align-items-center w-100">
                        <div
                          className={`${width === 0 ? 'p-0' : ''} ${styles.bar}`}
                          style={{ width: `${width}%`, backgroundColor: CHART_COLORS[idx % CHART_COLORS.length] }}
                        >
                          {
                            width >= 20
                              ? el.value
                              : ''
                          }
                        </div>
                        {width < 20 ? <span className="ml-2">{el.value}</span> : null}
                      </div>
                    </div>
                  )
                })
              }
            </div>
          </div>
        )
      }
    </div>
  );
};

export default React.memo(FordNrOfProjectsStages);
